
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { FeatureRouteGuard } from "@/components/common/FeatureRouteGuard";
import DocumentExtractionPage from "@/pages/documents/DocumentExtractionPage";
import { useState, useEffect } from "react";
import { useSystemSettings } from "@/hooks/useSystemSettings";

export function DocumentRoutes() {
  const { getPublicBooleanSetting } = useSystemSettings();
  const [subscriptionsEnabled, setSubscriptionsEnabled] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Check if subscriptions are enabled
  useEffect(() => {
    const checkSubscriptionsEnabled = async () => {
      try {
        setIsLoading(true);
        const enabled = await getPublicBooleanSetting('subscriptions_enabled', true);
        setSubscriptionsEnabled(enabled);
      } catch (error) {
        console.error("Error checking if subscriptions are enabled:", error);
        // Default to true if there's an error
        setSubscriptionsEnabled(true);
      } finally {
        setIsLoading(false);
      }
    };
    
    checkSubscriptionsEnabled();
  }, [getPublicBooleanSetting]);

  // Don't render anything while loading to prevent flashing
  if (isLoading) {
    return null;
  }

  return (
    <>
      <Route 
        path="/documents/extraction" 
        element={
          <ProtectedRoute>
            <FeatureRouteGuard feature="document_extraction">
              <DocumentExtractionPage />
            </FeatureRouteGuard>
          </ProtectedRoute>
        } 
      />
    </>
  );
}
